<template>
	<QrcodeNavCellShell
		:data="data"
		:editable="editable"
		:active="active"
		:h5="h5"
		@select="$emit('select')"
	/>
</template>

<script>
	import QrcodeNavCellShell from '../shared/QrcodeNavCellShell.vue';
	import { qrcodeNavMixin } from '../shared/mixin.js';

	export default {
		name: 'GBlockQrcodeNavCell',
		components: { QrcodeNavCellShell },
		mixins: [qrcodeNavMixin],
	};
</script>
